import { render, staticRenderFns } from "./InformationToFinancialUsers.vue?vue&type=template&id=3814572e&scoped=true&"
import script from "./InformationToFinancialUsers.vue?vue&type=script&lang=js&"
export * from "./InformationToFinancialUsers.vue?vue&type=script&lang=js&"
import style0 from "./InformationToFinancialUsers.vue?vue&type=style&index=0&id=3814572e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3814572e",
  null
  
)

export default component.exports